import React from 'react'
import { Icon, Table, } from 'semantic-ui-react'
import { FormikInputComponent, } from '../../../utilities/formUtils';
import { depositBankSubArray } from '../data/model';
import { Field, FieldArray } from 'formik'
import { useDispatch } from 'react-redux';
import { setAlertModalState } from '../../common/data/actions';
import LedgerSearch from '../../ledger_search/components/LedgerSearch';

const DepositBankArray = ({
    isLabel, label, saveOnBlur, decimal, compute, isTxn, path,values: parentValues,
    field, // { name, value, onChange, onBlur }
    ...props
}) => {

    const dispatch = useDispatch();

    const pushNewObj = (push) => {
        let subArray = depositBankSubArray()
        push(subArray)
    }

    const callToRemove = (index, remove) => {
        if (field.value.length > 1) {
            remove(index);
        } else {
            dispatch(setAlertModalState({ isOpen: true, type: "error", size: "mini", title: "Warning", msg: 'You are not allowed to delete remaining last row' }));
        }
    }

    const handleBankLedgerSelection = (e, values, setFieldValue, fieldName, obj, dispatch, index) => {
        if (obj) {
            setFieldValue(`${field.name}[${index}].bank_ledger`, obj.ledgerName)
            setFieldValue(`${field.name}[${index}].ledger_code`, obj.ledgerCode)
        }
    }

    const handleBankLedgerOnBlur = (e, values, setFieldValue, obj, dispatch, index) => {
        if (!e.target.value) {
            setFieldValue(`${field.name}[${index}].bank_ledger`, '')
            setFieldValue(`${field.name}[${index}].ledger_code`, '')
        }
    }

    return (
        <>
            <Table basic='very' style={{ marginTop: "-15px" }}>
                <FieldArray name={field.name}>
                    {({ remove: Remove, push: Push, values, setFieldValue }) => (
                        <>
                            {(field.value && field.value !== undefined && field.value !== null && field.value.length > 0) ? field.value.map((cc, index) => (
                                <React.Fragment key={index}>
                                    <Table.Row key={index} >
                                        <Table.Cell style={{ width: "20%" }}>
                                            <Field name={`${field.name}[${index}].deposit_bank`} component={FormikInputComponent} placeholder="Deposit Bank" isLabel='false' isTxn='true' />
                                        </Table.Cell>
                                        <Table.Cell style={{ width: "32%" }}>
                                            {/* <Field name={`${field.name}[${index}].bank_ledger`} component={FormikInputComponent} placeholder="Bank Ledger" isLabel='false' isTxn='true' /> */}
                                            <LedgerSearch name={`${field.name}[${index}].bank_ledger`} lgName="Bank" focus={false} isLabel={'false'} isTxn={false} isSelection={true} tabindex={0} dispatch={dispatch} placeholder="Search" label='RealBooks: Segment Ledger' className="ledgerSearch" isMandatory={false} getValue={handleBankLedgerSelection} onBlurFunction={handleBankLedgerOnBlur} onKeyUpFunction={null} isEditMode={false} values={values} index={index} cid={parentValues.cid} />
                                        </Table.Cell>
                                        <Table.Cell style={{ width: "15%" }}>
                                            <Field name={`${field.name}[${index}].ledger_code`} component={FormikInputComponent} placeholder="Bank Ledger Code" isLabel='false' isTxn='true' readOnly={true} className="readOnly" />
                                        </Table.Cell>
                                        <Table.Cell style={{ width: "1%", paddingRight: '0px' }} className="depositArray" ><Icon title='Add SubRow' onClick={() => pushNewObj(Push)} size='small' name="plus square" color='blue' /></Table.Cell>
                                        <Table.Cell style={{ width: "1%" }} className="depositArray"  > <Icon title='Delete SubRow' onClick={() => callToRemove(index, Remove)} size='small' name="trash alternate" color='red' /></Table.Cell>
                                    </Table.Row>
                                </React.Fragment>
                            )) : null}
                        </>
                    )}
                </FieldArray>
            </Table>
        </>
    )
}

export default DepositBankArray

